import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-120px)] bg-harmony-blue">
      <div className="max-w-md w-full text-center px-6 py-12 rounded-xl bg-harmony-blue-dark border border-harmony-white/10">
        <div>
          <h1 className="text-9xl font-extrabold text-harmony-orange">404</h1>
          <h2 className="mt-2 text-3xl font-bold text-harmony-white">Page Not Found</h2>
          <p className="mt-2 text-lg text-harmony-white/70">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        
        <div className="flex flex-col space-y-4 items-center mt-8">
          <Link
            to="/"
            className="w-48 py-2 px-4 rounded-md text-sm font-medium text-harmony-white bg-harmony-orange hover:bg-harmony-orange/90 transition-colors"
          >
            Go to Homepage
          </Link>
          
          <div className="flex space-x-4 mt-4">
            <Link
              to="/browse"
              className="text-sm font-medium text-harmony-white/70 hover:text-harmony-white hover:underline"
            >
              Browse Streams
            </Link>
            
            <Link
              to="/categories"
              className="text-sm font-medium text-harmony-white/70 hover:text-harmony-white hover:underline"
            >
              Browse Categories
            </Link>
            
            <Link
              to="/tournaments"
              className="text-sm font-medium text-harmony-white/70 hover:text-harmony-white hover:underline"
            >
              View Tournaments
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 